import LockKeyholeIcon from '@components/v2/icons/LockKeyhole';
import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { ToggleButton } from '@mui/material';
import { LockKeyholeOpen } from 'lucide-react';
import useWidth from '../../../../../../components/Hooks/useWidth';
import LangEnum from '../../../../../../lang/LangEnum';
import useGeneralSettingsStore from '../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import useProductDetailsStore from '../../../../../../stores/ProductDetails/productDetails.store';
import useSharedEntities from '../../../../../shared-entities/hooks/useSharedEntities';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { useProductLock } from '../../../hooks/useProductLock';
import { useProductFiltersStyles } from '../ProductFilters/styles/useProductFilters.styles';

const ProductLockFilter = () => {
  const lock = useProductLock();
  const { translate } = useTranslation();
  const { classes, cx } = useProductFiltersStyles();
  const { isPublicAccess } = useSharedEntities({});
  const { mobileWidth } = useWidth();
  const isFinishedOrder = useProductDetailsStore(
    (state) => state.productGridParams.isFinishedOrder,
  );
  const productInputLockValue = useGeneralSettingsStore(
    (state) => state.generalSettings.productInputLockValue,
  );

  if (isFinishedOrder || mobileWidth || isPublicAccess || !lock.isLockEnabled) {
    return null;
  }

  const isUnlocked = !lock.isLocked;
  const tooltipContent = translate(LangEnum.PRODUCT_INPUT_UNLOCK_MESSAGE, {
    max: productInputLockValue,
  });

  return (
    <Tooltip TooltipContent={tooltipContent} tabIndex={-1}>
      <ToggleButton
        value="lock"
        tabIndex={-1}
        selected={isUnlocked}
        aria-label={tooltipContent}
        className={cx(
          classes.filterButton,
          classes.lockFilterButton,
          isUnlocked && classes.selectedFilterButton,
        )}
        onClick={lock.onClickLock}
      >
        <Icon icon={lock.isLocked ? LockKeyholeIcon : LockKeyholeOpen} size="md" />
      </ToggleButton>
    </Tooltip>
  );
};

export default ProductLockFilter;
